import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

interface ServiceFeature {
  name: string;
  free: boolean;
  silver: boolean;
  gold: boolean;
  platino: boolean;
}

@Component({
  selector: 'app-pricing-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pricing-table.component.html',
  styleUrls: ['./pricing-table.component.scss']
})
export class PricingTableComponent {
  features: ServiceFeature[] = [
    {
      name: 'Post Instagram scaricabili',
      free: true,
      silver: true,
      gold: true,
      platino: true
    },
    {
      name: 'Calcolatori pratici',
      free: true,
      silver: true,
      gold: true,
      platino: true
    },
    {
      name: 'Newsletter',
      free: false,
      silver: true,
      gold: true,
      platino: true
    },
    {
      name: 'Portafoglio Modello',
      free: false,
      silver: true,
      gold: true,
      platino: true
    },
    {
      name: 'Chart & statistiche di mercato',
      free: false,
      silver: false,
      gold: true,
      platino: true
    },
    {
      name: 'Mercato Real-Time principali strumenti',
      free: false,
      silver: false,
      gold: true,
      platino: true
    },
    {
      name: 'Analisi del tuo portfolio',
      free: false,
      silver: false,
      gold: false,
      platino: true
    },
    {
      name: 'Pianificazione portfolio cliente',
      free: false,
      silver: false,
      gold: false,
      platino: true
    }
  ];
}

